<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>售后服务</span></div>
			<div class="center flex-between">
				<centerLeft :menu="8"></centerLeft>
				<div class="center-right">
					<div class="order-list" v-if="total > 0">
						<div class="order-item" v-for="(item, index) in list" :key="item.id">
							<div class="order-top">下单时间:{{item.createTime}}<span>售后单编号:{{item.returnNo}}</span></div>
							
							<div class="order-info flex-between flex-center">
								<img class="order-info-image" :src="item.goodsSpecImage"></img>
								<div class="order-info-name">
									<div class="title one">{{item.goodsName}}</div>
									<div class="spec">规格：{{item.goodsSpecName}}<span>退货数量：{{item.returnNum}}</span></div>
								</div>
								<div class="order-info-status" v-if="item.status == -1">已拒绝</div>
								<div class="order-info-status" v-if="item.status == 1">待审核</div>
								<div class="order-info-status" v-if="item.status == 2">已退款</div>
								<div class="order-info-button">
									<div class="order-info-button-button" @click="toInfo(item.id)">查看详情</div>
								</div>
								
							</div>
							
						</div>
					</div>
					<div class="page" v-if="total > 0">
					    <el-pagination @current-change="getPageList" :current-page="page" :page-size="limit" layout="total, prev, pager, next" :total="total"></el-pagination>
					</div>
					
					
					<noData v-if="list.length == 0 && isLoad == true" msg="暂无订单"></noData>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
import noData from '@/components/noData.vue'
import {orderReturnList} from "@/api/user"
export default {
	name: 'index',
	components:{
		centerLeft,
		noData
	},
	data(){
		return {
			list:[],
			page:1,
			limit:5,
			total:0,
			isLoad:false,
			status:"",
			time:[]
		}
	},
	mounted() {
		this.isLoad = false;
		this.getList();
	},
	methods:{
		getList(){
			orderReturnList({condition:{},page:this.page,size:this.limit}).then(res=>{
				if(res.code == 1000){
					this.list = res.data.list;
					this.total = res.data.total;
					this.isLoad = true;
				}else{
					return this.$message.error(res.message);
				}
			})
		},
		getPageList(e){
			this.isLoad = false;
			this.page = e;
			this.getList();
		},
		toInfo(id){
			this.$router.push("/userrefundinfo?id="+id);
		},
	}
}
</script>

<style lang="scss" scoped>
	.order-item{
		width: 960px;
		border: 1px solid rgba(7, 11, 19, 0.1);
		box-sizing: border-box;
		margin-top: 20px;
		.order-info{
			padding: 10px 40px 10px 20px;
			box-sizing: border-box;
			width: 100%;
			.order-info-image{
				width: 80px;
				height: 80px;
				border: 1px solid rgba(0, 0, 0, 0.1);
				flex: 0 0 82px;
				margin-right: 20px;
			}
			.order-info-name{
				font-size: 16px;
				color: #070B13;
				width: 100%;
				line-height: 40px;
				.title{
					max-width: 300px;
					display: inline-block;
				}
				.spec{
				   font-size: 16px;
				   color: #070B13;
				   opacity: 0.4;
				   span{
					   margin-left: 20px;
				   }
				}
			}
			.order-info-status{
				font-size: 16px;
				color: #070B13;
				flex: 0 0 100px;
				text-align: center;
			}
			.order-info-price{
				font-size: 14px;
				line-height: 22px;
				color: #070B13;
				text-align: center; 
				flex: 0 0 200px;
			}
			.order-info-button{
				width: 148px;
				text-align: center;
				flex: 0 0 148px;
				.order-info-button-button{
					width: 136px;
					height: 36px;
					background: #E91A12;
					font-size: 14px;
					line-height: 36px;
					color: #fff;
					text-align: center;
					cursor: pointer;
				}
			}
		}
		.order-top{
			width: 100%;
			height: 46px;
			background: rgba(233, 26, 18, 0.04);
			font-size: 16px;
			color: #070B13;
			line-height: 46px;
			padding-left: 20px;
			box-sizing: border-box;
			span{
				margin-left: 40px;
			}
		}
	}
	.order-list{
		min-height: 680px;
	}
	.order-search{
		margin-top: 18px;
		margin-bottom: 20px;
		.order-date{
			div{
				 font-size: 16px;
				 line-height: 22px;
				 color: #9E9E9E;
				 margin-right: 20px;
			}
		}
		.order-button{
			div{
				width: 60px;
				height: 44px;
				border: 1px solid rgba(233, 26, 18, 0.3);
				font-size: 14px;
				line-height: 44px;
				text-align: center;
				color: #070B13;
				margin-left: 16px;
				cursor: pointer;
			}
		}
	}
	.order-status{
		div{
			padding: 20px 0px 6px;
			font-size: 16px;
			line-height: 20px;
			color: #070B13;
			border-bottom: 3px solid #fff;
			margin-right: 60px;
			cursor: pointer;
		}
		.active{
			color: #E91A12;
			border-bottom: 3px solid #E91A12;
		}
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
